export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-foreground-900 via-foreground-800 to-foreground-950 p-8 md:p-12">
          <div className="absolute top-0 right-0 w-80 h-80 bg-primary-500/10 rounded-full -translate-y-1/3 translate-x-1/4 blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-accent-500/10 rounded-full translate-y-1/3 -translate-x-1/4 blur-3xl"></div>

          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
                黑料APP · 吃瓜更便捷
              </h2>
              <p className="text-background-50/70 text-sm md:text-base max-w-[500px] mx-auto lg:mx-0 mb-6">
                随时随地打开手机就能吃最新鲜的瓜。APP支持离线缓存、
                推送提醒、夜间模式等专属功能，吃瓜体验全面升级。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 hover:bg-background-100 text-foreground-900 font-semibold rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer no-underline"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-apple-fill text-lg"></i>
                  </div>
                  App Store 下载
                </a>
                <a
                  href="#"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 hover:bg-background-50/20 border border-background-50/30 text-background-50 font-semibold rounded-lg text-sm transition-all whitespace-nowrap cursor-pointer no-underline"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-android-fill text-lg"></i>
                  </div>
                  Android 下载
                </a>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="relative w-[180px] h-[360px] md:w-[220px] md:h-[440px] rounded-2xl overflow-hidden border-4 border-background-50/20 bg-background-50">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20app%20screenshot%20mockup%20with%20dark%20modern%20UI%2C%20news%20feed%20layout%20with%20cards%2C%20clean%20minimal%20design%2C%20red%20accent%20colors%2C%20Chinese%20text%20content%20layout%2C%20professional%20app%20interface%20design&width=440&height=880&seq=app-mockup&orientation=portrait"
                  alt="黑料APP界面预览"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}